import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DrawerContainer } from '../Drawer/DrawerContainer';
import { AccordionContainer } from '../Accordion/AccordionContainer';


@Component
export class FilterPills extends ThemeComponent {

    @Ref() filterButtons!: HTMLButtonElement[];

    private filterDrawer: DrawerContainer|null = document.querySelector('.filter-drawer');

    init() {
        // Each filter button should open the filter drawer
        // and open the relevant filter section
        for (const button of this.filterButtons) {
            this.$listen(button, 'click', () => {

                if (this.filterDrawer) {

                    // Close all accordions in the filter drawer
                    const filterAccordions = this.filterDrawer.querySelectorAll('accordion-container');
                    if (filterAccordions) {
                        for (const filterAccordion of filterAccordions) {
                            const accordion = filterAccordion as AccordionContainer;
                            if (button.getAttribute('data-filter') == accordion.getAttribute('data-filter')) {
                                accordion.open();
                            } else {
                                accordion.close();
                            }
                        }
                    }
                    this.filterDrawer.toggleOpen();

                }

            });
        }
    }
}
